<template>
	<div class="create_order">
		<div class="shop_top">
			<shop-top :subnav_show="false" :change_color="true"></shop-top>
		</div>
		<div class="width_center_1200" :class="signSuccess?'pay_success_icon':'pay_failed_icon'">
			<i v-if="signSuccess" class="icon iconfont">&#xe630;</i>
			<i v-else class="icon iconfont">&#xeba7;</i>
			<p v-if="signSuccess">快捷支付签约成功</p>
			<p v-else>快捷支付签约成功</p>
			<p class="last_info">前往用户中心 <router-link to="/user/order">查看</router-link>
			</p>
		</div>

		<shop-foot></shop-foot>
		<!-- vue 回到顶部 -->
		<el-backtop></el-backtop>
	</div>
</template>

<script>
	import ShopTop from "@/components/home/public/head.vue"
	import ShopFoot from "@/components/home/public/shop_foot.vue"
	import {
		unionPaymentSignNotify
	} from "@/api/api"
	export default {
		components: {
			ShopTop,
			ShopFoot,
		},
		props: {},
		data() {
			return {
				signSuccess: true,
				signResult:{
					accountNumber:'',
					mobile:'',
					channelType:'',
					accountType:''
				}
				
			};
		},
		watch: {},
		computed: {},
		methods: {

		},
		created() {
			if(this.$route.query){
				this.signResult.accountNumber = this.$route.query.accountNumber
				this.signResult.mobile = this.$route.query.mobile
				this.signResult.channelType = this.$route.query.channelType
				this.signResult.accountType = this.$route.query.accountType
			}
			if(this.signSuccess && this.signResult.accountNumber && this.signResult.mobile){
				//调用商城后台签约成功接口
				unionPaymentSignNotify(this.signResult)
			}
		},
		mounted() {}
	};
</script>
<style lang="scss" scoped>
	.join_bzt {
		margin-top: 40px;
	}

	.pay_success_icon {
		margin: 180px auto;
		text-align: center;
		line-height: 60px;

		i {
			font-size: 60px;
			color: #67c23a;
		}

		p.last_info {
			line-height: 20px;
			color: #666;
			font-size: 14px;

			a {
				color: #666;
			}

			a:hover {
				color: #ca151e;
			}
		}
	}

	.pay_failed_icon {
		margin: 180px auto;
		text-align: center;
		line-height: 60px;

		i {
			font-size: 60px;
			color: #ca151e;
		}

		p.last_info {
			line-height: 20px;
			color: #666;
			font-size: 14px;

			a {
				color: #666;
			}

			a:hover {
				color: #ca151e;
			}
		}
	}
</style>
